import { Pipe, PipeTransform } from '@angular/core';
import { DevelopmentProcess } from './development-process.component.type';

@Pipe({
    name: 'developmentProcess',
    standalone: true,
    pure: false,
})
export class DevelopmentProcessPipe implements PipeTransform {
    public transform(items: DevelopmentProcess[], needSorting: boolean): DevelopmentProcess[] {
        if (!needSorting) {
            return items;
        }
        return [...items].sort((a, b) => a.number - b.number);
    }
}
